module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.5.4 发布日志")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/group.html"
    }
  }, [_vm._v("Group")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] XSwitch的labelAlign 支持 justify #1707")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/sticky.html"
    }
  }, [_vm._v("Sticky")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 在 router-view 动画结束后自动重新绑定")]), _vm._v(" "), _c('li', [_vm._v("[fix] 修复在ios上fixed不生效的问题 #1657")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/tabbar.html"
    }
  }, [_vm._v("Tabbar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 增加事件 on-index-change #1715")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-img.html"
    }
  }, [_vm._v("XImg")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 在 router-view 动画结束后自动重新监听加载")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/bus.html"
    }
  }, [_vm._v("Bus")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 新插件，用于 vux 组件全局事件管理")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-46acb937", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-46acb937"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.5.4-245.vue
// module id = 2204
// module chunks = 276